// extracted by mini-css-extract-plugin
export default {"menuBlock":"xF-z","title":"yF-z","nav":"zF-z","flexCell":"AF-z","facetLink":"BF-z"};